import React from 'react';
import Loadable from 'react-loadable';

import { Activity } from 'reactor/components';

export default Loadable({
  loader: () => import('./Experiences'),
  loading: () => <Activity />,
  modules: ['Experiences'],
});
